// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add-exercise wizard — mobile-first, follows global light/dark (BrandContext) */
.training-theme-root.exercise-add-page {
  --exadd-ease: cubic-bezier(0.25, 1, 0.5, 1);
  min-height: 100vh;
  min-height: 100dvh;
  background: var(--bg-color) !important;
  color: var(--text-color);
  padding-bottom: calc(28px + env(safe-area-inset-bottom, 0px));
}

.training-theme-root.exercise-add-page .exercise-header {
  position: sticky;
  top: 0;
  z-index: 30;
  gap: 10px;
  padding: 10px 14px;
  min-height: 56px;
  background: color-mix(in srgb, var(--bg-color) 78%, transparent);
  backdrop-filter: blur(18px) saturate(1.2);
  -webkit-backdrop-filter: blur(18px) saturate(1.2);
  border-bottom: 1px solid color-mix(in srgb, var(--border-color) 80%, transparent);
}

.training-theme-root.exercise-add-page .exercise-header > h2 {
  color: var(--text-color);
  font-size: 17px;
  letter-spacing: -0.03em;
}

.training-theme-root.exercise-add-page .back-btn {
  width: 44px;
  height: 44px;
  background-color: color-mix(in srgb, var(--surface-color) 88%, transparent);
  border-color: var(--border-color);
  box-shadow: 0 2px 10px var(--shadow-color);
}

.dark-mode .training-theme-root.exercise-add-page .back-btn img {
  filter: brightness(0) saturate(100%) invert(100%) sepia(2%) saturate(0%)
    hue-rotate(135deg) brightness(104%) contrast(102%);
}

.training-theme-root.exercise-add-page .exadd-hero {
  padding: 16px 16px 8px;
  max-width: 720px;
  margin: 0 auto;
}

.training-theme-root.exercise-add-page .exadd-kicker {
  margin: 0 0 4px;
  font-size: 11px;
  font-weight: 750;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--brand-primary);
}

.training-theme-root.exercise-add-page .exadd-lead {
  margin: 0;
  font-size: 15px;
  line-height: 1.45;
  color: var(--text-secondary);
}

.training-theme-root.exercise-add-page .exadd-crumb,
.training-theme-root.exercise-add-page .exercise_type_define {
  max-width: 720px;
  margin: 8px auto 0;
  padding: 0 16px;
  font-size: 12px;
  font-weight: 650;
  letter-spacing: 0.02em;
  color: var(--brand-primary);
}

.training-theme-root.exercise-add-page .exercise_session_div.exadd-choices {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 10px;
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  padding: 12px 16px 24px;
}

.training-theme-root.exercise-add-page .session_add_box.exadd-choice {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  height: auto;
  min-height: 128px;
  margin: 0;
  padding: 16px 16px;
  border-radius: 16px;
  text-align: left;
  font: inherit;
  color: inherit;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.05),
    0 10px 18px -8px var(--shadow-color);
  transition:
    transform 0.28s var(--exadd-ease),
    box-shadow 0.28s ease,
    border-color 0.2s ease;
}

.training-theme-root.exercise-add-page .session_add_box.exadd-choice:hover {
  transform: translateY(-1px);
  border-color: color-mix(in srgb, var(--brand-primary) 40%, var(--border-color));
  box-shadow: 0 8px 22px color-mix(in srgb, var(--brand-primary) 16%, transparent);
}

.training-theme-root.exercise-add-page .session_add_box.exadd-choice:active {
  transform: scale(0.985);
}

.training-theme-root.exercise-add-page .session_add_box.exadd-choice:focus-visible {
  outline: 2px solid var(--brand-primary);
  outline-offset: 2px;
}

.training-theme-root.exercise-add-page .exadd-choice__icon,
.training-theme-root.exercise-add-page .session_add_box.exadd-choice .session-image-add,
.training-theme-root.exercise-add-page .session_add_box.exadd-choice .session-image-add2 {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    145deg,
    var(--brand-primary) 0%,
    var(--brand-primary-dark, #065a8f) 100%
  );
  box-shadow: 0 6px 14px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);
}

.training-theme-root.exercise-add-page .exadd-choice__icon svg,
.training-theme-root.exercise-add-page .session_add_box.exadd-choice .session-image-add svg,
.training-theme-root.exercise-add-page .session_add_box.exadd-choice .session-image-add2 svg {
  font-size: 20px;
  color: #fff;
  display: block;
}

.training-theme-root.exercise-add-page .exadd-choice__icon img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.session-image-add.exadd-choice__icon--type,
.session-image-add2.exadd-choice__icon--type,
.session-image-add2.exadd-choice__icon--mark,
.training-theme-root.exercise-add-page .session_add_box.exadd-choice .session-image-add.exadd-choice__icon--type,
.training-theme-root.exercise-add-page .session_add_box.exadd-choice .session-image-add2.exadd-choice__icon--type,
.training-theme-root.exercise-add-page .session_add_box.exadd-choice .session-image-add2.exadd-choice__icon--mark {
  width: 112px;
  height: 112px;
  border-radius: 22px;
  /* Neutral plate is transparent in the PNG; brand color shows through the hexagon. */
  background: color-mix(
    in srgb,
    var(--brand-primary-light, var(--brand-primary, #0877bc)) 14%,
    #ffffff
  );
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 20%, transparent);
  box-shadow: none;
  padding: 4px;
  overflow: hidden;
}

.session-image-add2.exadd-choice__icon--mark img,
.training-theme-root.exercise-add-page .exadd-choice__icon--mark img,
.training-theme-root.exercise-add-page .exadd-choice__icon--type img,
.session-image-add.exadd-choice__icon--type img,
.session-image-add2.exadd-choice__icon--type img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: transparent;
}

.dark-mode .training-theme-root.exercise-add-page .exadd-choice__icon--type,
.dark-mode .training-theme-root.exercise-add-page .exadd-choice__icon--mark,
html[data-theme="dark"] .training-theme-root.exercise-add-page .exadd-choice__icon--type,
html[data-theme="dark"] .training-theme-root.exercise-add-page .exadd-choice__icon--mark {
  background: color-mix(
    in srgb,
    var(--brand-primary-light, var(--brand-primary, #0877bc)) 22%,
    #1f2937
  );
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 32%, transparent);
}

.training-theme-root.exercise-add-page .ex-image-add--mark {
  width: 72px;
  height: 72px;
  border-radius: 16px;
  padding: 3px;
  box-sizing: border-box;
  background: color-mix(
    in srgb,
    var(--brand-primary-light, var(--brand-primary, #0877bc)) 14%,
    #ffffff
  );
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 20%, transparent);
  overflow: hidden;
}

.training-theme-root.exercise-add-page .ex-image-add--mark img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.dark-mode .training-theme-root.exercise-add-page .ex-image-add--mark,
html[data-theme="dark"] .training-theme-root.exercise-add-page .ex-image-add--mark {
  background: color-mix(
    in srgb,
    var(--brand-primary-light, var(--brand-primary, #0877bc)) 22%,
    #1f2937
  );
}

.training-theme-root.exercise-add-page .exadd-choice__copy,
.training-theme-root.exercise-add-page .session-addinfo,
.training-theme-root.exercise-add-page .session-addinfo h3 {
  color: var(--text-color);
}

.training-theme-root.exercise-add-page .session-addinfo h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.3;
}

.training-theme-root.exercise-add-page .expage-nav {
  position: sticky;
  top: 56px;
  z-index: 20;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: color-mix(in srgb, var(--bg-color) 82%, transparent);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-bottom: 1px solid var(--border-color);
}

.training-theme-root.exercise-add-page .expage-nav__breadcrumb {
  color: var(--brand-primary);
  white-space: normal;
}

.training-theme-root.exercise-add-page .expage-nav__count {
  color: var(--text-secondary);
  background: rgba(var(--brand-primary-rgb), 0.12);
}

.training-theme-root.exercise-add-page .expage-nav__add-btn {
  min-height: 44px;
  min-width: 72px;
  padding: 8px 16px;
  border: none;
  border-radius: 12px;
  background-color: var(--brand-primary);
  color: #fff;
  font-weight: 750;
}

.training-theme-root.exercise-add-page .expage-nav__add-btn:hover {
  background-color: var(--brand-primary-dark, #065a8f);
}

.training-theme-root.exercise-add-page .error_msg {
  color: #ff8a80;
}

.light-mode .training-theme-root.exercise-add-page .error_msg {
  color: #c62828;
}

.training-theme-root.exercise-add-page .expage-theme-sort {
  max-width: 880px;
  margin: 0 auto;
  padding: 8px 16px 0;
}

.training-theme-root.exercise-add-page .expage-theme-sort__label {
  color: var(--text-secondary);
}

.training-theme-root.exercise-add-page .expage-theme-sort__chip {
  min-height: 36px;
  background: var(--surface-color);
  color: var(--text-color);
  border-color: var(--border-color);
}

.training-theme-root.exercise-add-page .expage-theme-sort__chip--active {
  background: var(--brand-primary);
  border-color: var(--brand-primary);
  color: #fff;
}

/* Inactive chips only — active keeps brand fill + white text in bright mode. */
.light-mode .training-theme-root.exercise-add-page .expage-theme-sort__chip:not(.expage-theme-sort__chip--active),
.light-mode .training-theme-root.exercise-add-page .excard,
.light-mode .training-theme-root.exercise-add-page .session_add_box,
.light-mode .training-theme-root.exercise-add-page .ex_add_box {
  background: var(--brand-surface, #ffffff) !important;
}

.light-mode .training-theme-root.exercise-add-page .expage-theme-sort__chip--active {
  background: var(--brand-primary, #0877bc) !important;
  border-color: var(--brand-primary, #0877bc) !important;
  color: #fff !important;
}

.light-mode .training-theme-root.exercise-add-page .excard-header__duration-input,
.light-mode .training-theme-root.exercise-add-page .excard-expand__content,
.light-mode .training-theme-root.exercise-add-page .dms-input__field {
  background: var(--bg-color) !important;
}

.training-theme-root.exercise-add-page .dms-input__field {
  background: var(--bg-color);
  color: var(--text-color);
  border-color: var(--border-color);
}

.training-theme-root.exercise-add-page .dms-input__unit,
.training-theme-root.exercise-add-page .excard-header__duration-unit,
.training-theme-root.exercise-add-page .excard-header__duration-icon {
  color: var(--text-secondary) !important;
}

.dark-mode .training-theme-root.exercise-add-page .dms-input__unit,
.dark-mode .training-theme-root.exercise-add-page .excard-header__duration-unit,
html[data-theme="dark"] .training-theme-root.exercise-add-page .dms-input__unit {
  color: color-mix(in srgb, var(--text-color, #f9fafb) 78%, transparent) !important;
}

.training-theme-root.exercise-add-page .exadd-duration-field {
  display: block;
  margin: 8px 0 16px;
  max-width: 140px;
  min-height: 44px;
  padding: 8px 12px;
  border-radius: 12px;
  border: 1px solid var(--border-color);
  background: var(--surface-color);
  color: var(--text-color);
  font: inherit;
  font-size: 16px;
}

.training-theme-root.exercise-add-page label.exadd-lead {
  display: block;
  color: var(--text-color);
  font-weight: 650;
}

.training-theme-root.exercise-add-page .expage-recommend-hint,
.training-theme-root.exercise-add-page .exercise-add-muted-text {
  color: var(--text-secondary);
}

.training-theme-root.exercise-add-page .expage-grid {
  max-width: 880px;
  margin: 0 auto;
  /* Room for fixed mobile dock (count + Add) sitting above the app bottom nav */
  padding-bottom: calc(168px + env(safe-area-inset-bottom, 0px));
}

.training-theme-root.exercise-add-page .excard {
  background: var(--surface-color);
  border-color: var(--border-color);
  box-shadow: 0 2px 10px var(--shadow-color);
}

.training-theme-root.exercise-add-page .excard:hover {
  box-shadow: 0 4px 16px var(--shadow-color);
}

.training-theme-root.exercise-add-page .excard--selected {
  border-color: var(--brand-primary);
  background: linear-gradient(
    135deg,
    rgba(var(--brand-primary-rgb), 0.1) 0%,
    var(--surface-color) 40%
  );
  box-shadow: 0 4px 18px rgba(var(--brand-primary-rgb), 0.2);
}

.training-theme-root.exercise-add-page .excard-header__name {
  color: var(--text-color);
}

.training-theme-root.exercise-add-page .excard-header__desc,
.training-theme-root.exercise-add-page .excard-header__duration-unit,
.training-theme-root.exercise-add-page .excard-header__duration-icon,
.training-theme-root.exercise-add-page .excard-section__text,
.training-theme-root.exercise-add-page .excard-section__focus-item,
.training-theme-root.exercise-add-page .excard-expand__content,
.training-theme-root.exercise-add-page .dms-input__unit {
  color: var(--text-secondary);
}

.training-theme-root.exercise-add-page .excard-header__duration-input,
.training-theme-root.exercise-add-page .dms-input__field {
  background: var(--bg-color);
  color: var(--text-color);
  border-color: var(--border-color);
}

.training-theme-root.exercise-add-page .excard-header__duration-input:focus,
.training-theme-root.exercise-add-page .dms-input__field:focus {
  border-color: var(--brand-primary);
  background: var(--bg-color);
}

.training-theme-root.exercise-add-page .excard-header__select-btn {
  min-height: 44px;
  background: var(--surface-color);
  border-color: var(--border-color);
  color: var(--text-secondary);
}

.training-theme-root.exercise-add-page .excard-expand {
  border-top-color: var(--border-color);
}

.training-theme-root.exercise-add-page .excard-expand__content {
  background: var(--bg-color);
}

.training-theme-root.exercise-add-page .ex_add_box {
  background: var(--surface-color) !important;
  border-color: var(--border-color) !important;
  box-shadow: 0 2px 12px var(--shadow-color) !important;
  color: var(--text-color);
}

.training-theme-root.exercise-add-page .ex_add_box__title,
.training-theme-root.exercise-add-page .exercise-addinfo h4 {
  color: var(--text-color);
}

.training-theme-root.exercise-add-page .ex_add_box__subtitle,
.training-theme-root.exercise-add-page .ex_add_box__min,
.training-theme-root.exercise-add-page .ex_add_box__state-text {
  color: var(--text-secondary) !important;
}

.training-theme-root.exercise-add-page .exercise-add-recommend-row {
  margin-bottom: 12px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  padding: 0 16px;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
}

.training-theme-root.exercise-add-page .exercise-add-recommend-row__hint {
  font-size: 13px;
  color: var(--text-secondary);
}

.training-theme-root.exercise-add-page .exercise-add-toggle-btn {
  font-size: 12px;
  min-height: 36px;
  padding: 6px 12px;
  background-color: var(--brand-primary);
  color: #fff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

.training-theme-root.exercise-add-page .exercise-add-toggle-btn:hover {
  background-color: var(--brand-primary-dark, #065a8f);
}

.training-theme-root.exercise-add-page .exadd-dock {
  /* Fixed above the floating bottom nav so Add stays reachable while scrolling */
  position: fixed;
  left: 0;
  right: 0;
  bottom: calc(80px + env(safe-area-inset-bottom, 0px));
  z-index: 998;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  padding: 12px 16px;
  background: color-mix(in srgb, var(--bg-color) 92%, transparent);
  backdrop-filter: blur(18px) saturate(1.15);
  -webkit-backdrop-filter: blur(18px) saturate(1.15);
  border-top: 1px solid var(--border-color);
  box-shadow: 0 -8px 24px var(--shadow-color);
}

.training-theme-root.exercise-add-page .exadd-dock__count {
  font-size: 13px;
  font-weight: 700;
  color: var(--text-secondary);
  text-align: center;
}

.training-theme-root.exercise-add-page .exadd-dock__btn {
  width: 100%;
  min-height: 48px;
  border: none;
  border-radius: 14px;
  font: inherit;
  font-size: 16px;
  font-weight: 750;
  letter-spacing: -0.02em;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(
    135deg,
    var(--brand-primary) 0%,
    var(--brand-primary-dark, #065a8f) 100%
  );
  box-shadow: 0 6px 16px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.32);
}

.training-theme-root.exercise-add-page .exadd-dock__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}

.training-theme-root.exercise-add-page .exadd-dock__btn:not(:disabled):active {
  transform: scale(0.98);
}

.dark-mode .training-theme-root.exercise-add-page .excard-tag--type {
  background: rgba(33, 150, 243, 0.18);
  color: #90caf9;
}

.dark-mode .training-theme-root.exercise-add-page .excard-tag--cardio {
  background: rgba(255, 152, 0, 0.16);
  color: #ffb74d;
}

.dark-mode .training-theme-root.exercise-add-page .excard-tag--subtype,
.dark-mode .training-theme-root.exercise-add-page .excard-tag--cb {
  background: color-mix(in srgb, var(--brand-secondary, #2e7d32) 28%, transparent);
  color: color-mix(in srgb, var(--brand-secondary, #81c784) 70%, #fff);
}

.dark-mode .training-theme-root.exercise-add-page .excard-badge--skill {
  background: rgba(38, 166, 154, 0.18);
  color: #80cbc4;
  border-color: rgba(128, 203, 196, 0.35);
}

.dark-mode .training-theme-root.exercise-add-page .excard-badge--focus {
  background: rgba(255, 152, 0, 0.16);
  color: #ffcc80;
  border-color: rgba(255, 204, 128, 0.35);
}

@media (min-width: 720px) {
  .training-theme-root.exercise-add-page .exercise_session_div.exadd-choices {
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-width: 880px;
    padding-top: 16px;
  }

  .training-theme-root.exercise-add-page .exadd-hero,
  .training-theme-root.exercise-add-page .exadd-crumb,
  .training-theme-root.exercise-add-page .exercise_type_define {
    max-width: 880px;
  }

  .training-theme-root.exercise-add-page .exadd-dock {
    display: none;
  }

  .training-theme-root.exercise-add-page .expage-grid {
    padding-bottom: 24px;
  }
}

@media (max-width: 719px) {
  .training-theme-root.exercise-add-page .expage-nav__add-btn {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Exerciseadd/ExerciseAddTheme.css"],"names":[],"mappings":"AAAA,iFAAiF;AACjF;EACE,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,wBAAwB;EACxB,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gEAAgE;EAChE,yCAAyC;EACzC,iDAAiD;EACjD,iFAAiF;AACnF;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2EAA2E;EAC3E,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE;sDACoD;AACtD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,qCAAqC;EACrC;;wCAEsC;EACtC;;;0BAGwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,+EAA+E;EAC/E,gFAAgF;AAClF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;;;GAIC;EACD,wEAAwE;AAC1E;;AAEA;;;EAGE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;;;;EAME,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oFAAoF;EACpF;;;;GAIC;EACD,oFAAoF;EACpF,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;EAIE;;;;GAIC;EACD,gFAAgF;AAClF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB;;;;GAIC;EACD,oFAAoF;EACpF,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE;;;;GAIC;AACH;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gEAAgE;EAChE,2BAA2B;EAC3B,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,WAAW;AACb;;AAEA,+EAA+E;AAC/E;;;;EAIE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;EACpD,sDAAsD;EACtD,sBAAsB;AACxB;;AAEA;;;EAGE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;;EAGE,iFAAiF;AACnF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;EAChC,wBAAwB;EACxB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,8EAA8E;EAC9E,8DAA8D;AAChE;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC;;;;GAIC;EACD,0DAA0D;AAC5D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;;;EAOE,4BAA4B;AAC9B;;AAEA;;EAEE,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;;EAEE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,qDAAqD;EACrD,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,+EAA+E;EAC/E,eAAe;EACf,OAAO;EACP,QAAQ;EACR,qDAAqD;EACrD,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,kBAAkB;EAClB,gEAAgE;EAChE,0CAA0C;EAC1C,kDAAkD;EAClD,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf;;;;GAIC;EACD,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;EAEE,gFAAgF;EAChF,oEAAoE;AACtE;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* Add-exercise wizard — mobile-first, follows global light/dark (BrandContext) */\n.training-theme-root.exercise-add-page {\n  --exadd-ease: cubic-bezier(0.25, 1, 0.5, 1);\n  min-height: 100vh;\n  min-height: 100dvh;\n  background: var(--bg-color) !important;\n  color: var(--text-color);\n  padding-bottom: calc(28px + env(safe-area-inset-bottom, 0px));\n}\n\n.training-theme-root.exercise-add-page .exercise-header {\n  position: sticky;\n  top: 0;\n  z-index: 30;\n  gap: 10px;\n  padding: 10px 14px;\n  min-height: 56px;\n  background: color-mix(in srgb, var(--bg-color) 78%, transparent);\n  backdrop-filter: blur(18px) saturate(1.2);\n  -webkit-backdrop-filter: blur(18px) saturate(1.2);\n  border-bottom: 1px solid color-mix(in srgb, var(--border-color) 80%, transparent);\n}\n\n.training-theme-root.exercise-add-page .exercise-header > h2 {\n  color: var(--text-color);\n  font-size: 17px;\n  letter-spacing: -0.03em;\n}\n\n.training-theme-root.exercise-add-page .back-btn {\n  width: 44px;\n  height: 44px;\n  background-color: color-mix(in srgb, var(--surface-color) 88%, transparent);\n  border-color: var(--border-color);\n  box-shadow: 0 2px 10px var(--shadow-color);\n}\n\n.dark-mode .training-theme-root.exercise-add-page .back-btn img {\n  filter: brightness(0) saturate(100%) invert(100%) sepia(2%) saturate(0%)\n    hue-rotate(135deg) brightness(104%) contrast(102%);\n}\n\n.training-theme-root.exercise-add-page .exadd-hero {\n  padding: 16px 16px 8px;\n  max-width: 720px;\n  margin: 0 auto;\n}\n\n.training-theme-root.exercise-add-page .exadd-kicker {\n  margin: 0 0 4px;\n  font-size: 11px;\n  font-weight: 750;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--brand-primary);\n}\n\n.training-theme-root.exercise-add-page .exadd-lead {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.45;\n  color: var(--text-secondary);\n}\n\n.training-theme-root.exercise-add-page .exadd-crumb,\n.training-theme-root.exercise-add-page .exercise_type_define {\n  max-width: 720px;\n  margin: 8px auto 0;\n  padding: 0 16px;\n  font-size: 12px;\n  font-weight: 650;\n  letter-spacing: 0.02em;\n  color: var(--brand-primary);\n}\n\n.training-theme-root.exercise-add-page .exercise_session_div.exadd-choices {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  gap: 10px;\n  width: 100%;\n  max-width: 720px;\n  margin: 0 auto;\n  padding: 12px 16px 24px;\n}\n\n.training-theme-root.exercise-add-page .session_add_box.exadd-choice {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n  height: auto;\n  min-height: 128px;\n  margin: 0;\n  padding: 16px 16px;\n  border-radius: 16px;\n  text-align: left;\n  font: inherit;\n  color: inherit;\n  background: var(--surface-color);\n  border: 1px solid var(--border-color);\n  box-shadow:\n    0 4px 6px -1px rgba(0, 0, 0, 0.05),\n    0 10px 18px -8px var(--shadow-color);\n  transition:\n    transform 0.28s var(--exadd-ease),\n    box-shadow 0.28s ease,\n    border-color 0.2s ease;\n}\n\n.training-theme-root.exercise-add-page .session_add_box.exadd-choice:hover {\n  transform: translateY(-1px);\n  border-color: color-mix(in srgb, var(--brand-primary) 40%, var(--border-color));\n  box-shadow: 0 8px 22px color-mix(in srgb, var(--brand-primary) 16%, transparent);\n}\n\n.training-theme-root.exercise-add-page .session_add_box.exadd-choice:active {\n  transform: scale(0.985);\n}\n\n.training-theme-root.exercise-add-page .session_add_box.exadd-choice:focus-visible {\n  outline: 2px solid var(--brand-primary);\n  outline-offset: 2px;\n}\n\n.training-theme-root.exercise-add-page .exadd-choice__icon,\n.training-theme-root.exercise-add-page .session_add_box.exadd-choice .session-image-add,\n.training-theme-root.exercise-add-page .session_add_box.exadd-choice .session-image-add2 {\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(\n    145deg,\n    var(--brand-primary) 0%,\n    var(--brand-primary-dark, #065a8f) 100%\n  );\n  box-shadow: 0 6px 14px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);\n}\n\n.training-theme-root.exercise-add-page .exadd-choice__icon svg,\n.training-theme-root.exercise-add-page .session_add_box.exadd-choice .session-image-add svg,\n.training-theme-root.exercise-add-page .session_add_box.exadd-choice .session-image-add2 svg {\n  font-size: 20px;\n  color: #fff;\n  display: block;\n}\n\n.training-theme-root.exercise-add-page .exadd-choice__icon img {\n  width: 28px;\n  height: 28px;\n  object-fit: contain;\n}\n\n.session-image-add.exadd-choice__icon--type,\n.session-image-add2.exadd-choice__icon--type,\n.session-image-add2.exadd-choice__icon--mark,\n.training-theme-root.exercise-add-page .session_add_box.exadd-choice .session-image-add.exadd-choice__icon--type,\n.training-theme-root.exercise-add-page .session_add_box.exadd-choice .session-image-add2.exadd-choice__icon--type,\n.training-theme-root.exercise-add-page .session_add_box.exadd-choice .session-image-add2.exadd-choice__icon--mark {\n  width: 112px;\n  height: 112px;\n  border-radius: 22px;\n  /* Neutral plate is transparent in the PNG; brand color shows through the hexagon. */\n  background: color-mix(\n    in srgb,\n    var(--brand-primary-light, var(--brand-primary, #0877bc)) 14%,\n    #ffffff\n  );\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 20%, transparent);\n  box-shadow: none;\n  padding: 4px;\n  overflow: hidden;\n}\n\n.session-image-add2.exadd-choice__icon--mark img,\n.training-theme-root.exercise-add-page .exadd-choice__icon--mark img,\n.training-theme-root.exercise-add-page .exadd-choice__icon--type img,\n.session-image-add.exadd-choice__icon--type img,\n.session-image-add2.exadd-choice__icon--type img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background: transparent;\n}\n\n.dark-mode .training-theme-root.exercise-add-page .exadd-choice__icon--type,\n.dark-mode .training-theme-root.exercise-add-page .exadd-choice__icon--mark,\nhtml[data-theme=\"dark\"] .training-theme-root.exercise-add-page .exadd-choice__icon--type,\nhtml[data-theme=\"dark\"] .training-theme-root.exercise-add-page .exadd-choice__icon--mark {\n  background: color-mix(\n    in srgb,\n    var(--brand-primary-light, var(--brand-primary, #0877bc)) 22%,\n    #1f2937\n  );\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 32%, transparent);\n}\n\n.training-theme-root.exercise-add-page .ex-image-add--mark {\n  width: 72px;\n  height: 72px;\n  border-radius: 16px;\n  padding: 3px;\n  box-sizing: border-box;\n  background: color-mix(\n    in srgb,\n    var(--brand-primary-light, var(--brand-primary, #0877bc)) 14%,\n    #ffffff\n  );\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 20%, transparent);\n  overflow: hidden;\n}\n\n.training-theme-root.exercise-add-page .ex-image-add--mark img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.dark-mode .training-theme-root.exercise-add-page .ex-image-add--mark,\nhtml[data-theme=\"dark\"] .training-theme-root.exercise-add-page .ex-image-add--mark {\n  background: color-mix(\n    in srgb,\n    var(--brand-primary-light, var(--brand-primary, #0877bc)) 22%,\n    #1f2937\n  );\n}\n\n.training-theme-root.exercise-add-page .exadd-choice__copy,\n.training-theme-root.exercise-add-page .session-addinfo,\n.training-theme-root.exercise-add-page .session-addinfo h3 {\n  color: var(--text-color);\n}\n\n.training-theme-root.exercise-add-page .session-addinfo h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.3;\n}\n\n.training-theme-root.exercise-add-page .expage-nav {\n  position: sticky;\n  top: 56px;\n  z-index: 20;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 16px;\n  background: color-mix(in srgb, var(--bg-color) 82%, transparent);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.training-theme-root.exercise-add-page .expage-nav__breadcrumb {\n  color: var(--brand-primary);\n  white-space: normal;\n}\n\n.training-theme-root.exercise-add-page .expage-nav__count {\n  color: var(--text-secondary);\n  background: rgba(var(--brand-primary-rgb), 0.12);\n}\n\n.training-theme-root.exercise-add-page .expage-nav__add-btn {\n  min-height: 44px;\n  min-width: 72px;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 12px;\n  background-color: var(--brand-primary);\n  color: #fff;\n  font-weight: 750;\n}\n\n.training-theme-root.exercise-add-page .expage-nav__add-btn:hover {\n  background-color: var(--brand-primary-dark, #065a8f);\n}\n\n.training-theme-root.exercise-add-page .error_msg {\n  color: #ff8a80;\n}\n\n.light-mode .training-theme-root.exercise-add-page .error_msg {\n  color: #c62828;\n}\n\n.training-theme-root.exercise-add-page .expage-theme-sort {\n  max-width: 880px;\n  margin: 0 auto;\n  padding: 8px 16px 0;\n}\n\n.training-theme-root.exercise-add-page .expage-theme-sort__label {\n  color: var(--text-secondary);\n}\n\n.training-theme-root.exercise-add-page .expage-theme-sort__chip {\n  min-height: 36px;\n  background: var(--surface-color);\n  color: var(--text-color);\n  border-color: var(--border-color);\n}\n\n.training-theme-root.exercise-add-page .expage-theme-sort__chip--active {\n  background: var(--brand-primary);\n  border-color: var(--brand-primary);\n  color: #fff;\n}\n\n/* Inactive chips only — active keeps brand fill + white text in bright mode. */\n.light-mode .training-theme-root.exercise-add-page .expage-theme-sort__chip:not(.expage-theme-sort__chip--active),\n.light-mode .training-theme-root.exercise-add-page .excard,\n.light-mode .training-theme-root.exercise-add-page .session_add_box,\n.light-mode .training-theme-root.exercise-add-page .ex_add_box {\n  background: var(--brand-surface, #ffffff) !important;\n}\n\n.light-mode .training-theme-root.exercise-add-page .expage-theme-sort__chip--active {\n  background: var(--brand-primary, #0877bc) !important;\n  border-color: var(--brand-primary, #0877bc) !important;\n  color: #fff !important;\n}\n\n.light-mode .training-theme-root.exercise-add-page .excard-header__duration-input,\n.light-mode .training-theme-root.exercise-add-page .excard-expand__content,\n.light-mode .training-theme-root.exercise-add-page .dms-input__field {\n  background: var(--bg-color) !important;\n}\n\n.training-theme-root.exercise-add-page .dms-input__field {\n  background: var(--bg-color);\n  color: var(--text-color);\n  border-color: var(--border-color);\n}\n\n.training-theme-root.exercise-add-page .dms-input__unit,\n.training-theme-root.exercise-add-page .excard-header__duration-unit,\n.training-theme-root.exercise-add-page .excard-header__duration-icon {\n  color: var(--text-secondary) !important;\n}\n\n.dark-mode .training-theme-root.exercise-add-page .dms-input__unit,\n.dark-mode .training-theme-root.exercise-add-page .excard-header__duration-unit,\nhtml[data-theme=\"dark\"] .training-theme-root.exercise-add-page .dms-input__unit {\n  color: color-mix(in srgb, var(--text-color, #f9fafb) 78%, transparent) !important;\n}\n\n.training-theme-root.exercise-add-page .exadd-duration-field {\n  display: block;\n  margin: 8px 0 16px;\n  max-width: 140px;\n  min-height: 44px;\n  padding: 8px 12px;\n  border-radius: 12px;\n  border: 1px solid var(--border-color);\n  background: var(--surface-color);\n  color: var(--text-color);\n  font: inherit;\n  font-size: 16px;\n}\n\n.training-theme-root.exercise-add-page label.exadd-lead {\n  display: block;\n  color: var(--text-color);\n  font-weight: 650;\n}\n\n.training-theme-root.exercise-add-page .expage-recommend-hint,\n.training-theme-root.exercise-add-page .exercise-add-muted-text {\n  color: var(--text-secondary);\n}\n\n.training-theme-root.exercise-add-page .expage-grid {\n  max-width: 880px;\n  margin: 0 auto;\n  /* Room for fixed mobile dock (count + Add) sitting above the app bottom nav */\n  padding-bottom: calc(168px + env(safe-area-inset-bottom, 0px));\n}\n\n.training-theme-root.exercise-add-page .excard {\n  background: var(--surface-color);\n  border-color: var(--border-color);\n  box-shadow: 0 2px 10px var(--shadow-color);\n}\n\n.training-theme-root.exercise-add-page .excard:hover {\n  box-shadow: 0 4px 16px var(--shadow-color);\n}\n\n.training-theme-root.exercise-add-page .excard--selected {\n  border-color: var(--brand-primary);\n  background: linear-gradient(\n    135deg,\n    rgba(var(--brand-primary-rgb), 0.1) 0%,\n    var(--surface-color) 40%\n  );\n  box-shadow: 0 4px 18px rgba(var(--brand-primary-rgb), 0.2);\n}\n\n.training-theme-root.exercise-add-page .excard-header__name {\n  color: var(--text-color);\n}\n\n.training-theme-root.exercise-add-page .excard-header__desc,\n.training-theme-root.exercise-add-page .excard-header__duration-unit,\n.training-theme-root.exercise-add-page .excard-header__duration-icon,\n.training-theme-root.exercise-add-page .excard-section__text,\n.training-theme-root.exercise-add-page .excard-section__focus-item,\n.training-theme-root.exercise-add-page .excard-expand__content,\n.training-theme-root.exercise-add-page .dms-input__unit {\n  color: var(--text-secondary);\n}\n\n.training-theme-root.exercise-add-page .excard-header__duration-input,\n.training-theme-root.exercise-add-page .dms-input__field {\n  background: var(--bg-color);\n  color: var(--text-color);\n  border-color: var(--border-color);\n}\n\n.training-theme-root.exercise-add-page .excard-header__duration-input:focus,\n.training-theme-root.exercise-add-page .dms-input__field:focus {\n  border-color: var(--brand-primary);\n  background: var(--bg-color);\n}\n\n.training-theme-root.exercise-add-page .excard-header__select-btn {\n  min-height: 44px;\n  background: var(--surface-color);\n  border-color: var(--border-color);\n  color: var(--text-secondary);\n}\n\n.training-theme-root.exercise-add-page .excard-expand {\n  border-top-color: var(--border-color);\n}\n\n.training-theme-root.exercise-add-page .excard-expand__content {\n  background: var(--bg-color);\n}\n\n.training-theme-root.exercise-add-page .ex_add_box {\n  background: var(--surface-color) !important;\n  border-color: var(--border-color) !important;\n  box-shadow: 0 2px 12px var(--shadow-color) !important;\n  color: var(--text-color);\n}\n\n.training-theme-root.exercise-add-page .ex_add_box__title,\n.training-theme-root.exercise-add-page .exercise-addinfo h4 {\n  color: var(--text-color);\n}\n\n.training-theme-root.exercise-add-page .ex_add_box__subtitle,\n.training-theme-root.exercise-add-page .ex_add_box__min,\n.training-theme-root.exercise-add-page .ex_add_box__state-text {\n  color: var(--text-secondary) !important;\n}\n\n.training-theme-root.exercise-add-page .exercise-add-recommend-row {\n  margin-bottom: 12px;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  align-items: center;\n  padding: 0 16px;\n  max-width: 720px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.training-theme-root.exercise-add-page .exercise-add-recommend-row__hint {\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.training-theme-root.exercise-add-page .exercise-add-toggle-btn {\n  font-size: 12px;\n  min-height: 36px;\n  padding: 6px 12px;\n  background-color: var(--brand-primary);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.training-theme-root.exercise-add-page .exercise-add-toggle-btn:hover {\n  background-color: var(--brand-primary-dark, #065a8f);\n}\n\n.training-theme-root.exercise-add-page .exadd-dock {\n  /* Fixed above the floating bottom nav so Add stays reachable while scrolling */\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: calc(80px + env(safe-area-inset-bottom, 0px));\n  z-index: 998;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 10px;\n  padding: 12px 16px;\n  background: color-mix(in srgb, var(--bg-color) 92%, transparent);\n  backdrop-filter: blur(18px) saturate(1.15);\n  -webkit-backdrop-filter: blur(18px) saturate(1.15);\n  border-top: 1px solid var(--border-color);\n  box-shadow: 0 -8px 24px var(--shadow-color);\n}\n\n.training-theme-root.exercise-add-page .exadd-dock__count {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--text-secondary);\n  text-align: center;\n}\n\n.training-theme-root.exercise-add-page .exadd-dock__btn {\n  width: 100%;\n  min-height: 48px;\n  border: none;\n  border-radius: 14px;\n  font: inherit;\n  font-size: 16px;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n  color: #fff;\n  cursor: pointer;\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary) 0%,\n    var(--brand-primary-dark, #065a8f) 100%\n  );\n  box-shadow: 0 6px 16px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.32);\n}\n\n.training-theme-root.exercise-add-page .exadd-dock__btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.training-theme-root.exercise-add-page .exadd-dock__btn:not(:disabled):active {\n  transform: scale(0.98);\n}\n\n.dark-mode .training-theme-root.exercise-add-page .excard-tag--type {\n  background: rgba(33, 150, 243, 0.18);\n  color: #90caf9;\n}\n\n.dark-mode .training-theme-root.exercise-add-page .excard-tag--cardio {\n  background: rgba(255, 152, 0, 0.16);\n  color: #ffb74d;\n}\n\n.dark-mode .training-theme-root.exercise-add-page .excard-tag--subtype,\n.dark-mode .training-theme-root.exercise-add-page .excard-tag--cb {\n  background: color-mix(in srgb, var(--brand-secondary, #2e7d32) 28%, transparent);\n  color: color-mix(in srgb, var(--brand-secondary, #81c784) 70%, #fff);\n}\n\n.dark-mode .training-theme-root.exercise-add-page .excard-badge--skill {\n  background: rgba(38, 166, 154, 0.18);\n  color: #80cbc4;\n  border-color: rgba(128, 203, 196, 0.35);\n}\n\n.dark-mode .training-theme-root.exercise-add-page .excard-badge--focus {\n  background: rgba(255, 152, 0, 0.16);\n  color: #ffcc80;\n  border-color: rgba(255, 204, 128, 0.35);\n}\n\n@media (min-width: 720px) {\n  .training-theme-root.exercise-add-page .exercise_session_div.exadd-choices {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    max-width: 880px;\n    padding-top: 16px;\n  }\n\n  .training-theme-root.exercise-add-page .exadd-hero,\n  .training-theme-root.exercise-add-page .exadd-crumb,\n  .training-theme-root.exercise-add-page .exercise_type_define {\n    max-width: 880px;\n  }\n\n  .training-theme-root.exercise-add-page .exadd-dock {\n    display: none;\n  }\n\n  .training-theme-root.exercise-add-page .expage-grid {\n    padding-bottom: 24px;\n  }\n}\n\n@media (max-width: 719px) {\n  .training-theme-root.exercise-add-page .expage-nav__add-btn {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
